module.exports = __webpack_public_path__ + "static/media/turkey.77291339.png";